module.exports = __webpack_public_path__ + "static/media/MTL_SL_BOSS4.4f88ebb0.png";